import UpsRegistration from 'app/models/ups_registration';

import { showError } from 'utils/messages';
import { setLocation } from 'utils/wrappers';

import UpsLicenseModal from 'app/views/modals/ups_license_modal';

import Base from 'app/views/base';
import tmpl from 'templates/ups_account_registration_page';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'submit #ups-registration-form': 'register',
    'click #license_button': 'showLicense',
  },

  initialize() {
    this.model = new UpsRegistration({});
    this.licenseModal = new UpsLicenseModal({});
  },

  showLicense(event) {
    event.preventDefault();
    this.licenseModal.show();
  },

  register(e) {
    e.preventDefault();
    const $e = this.$el;

    this.model.save({
      account_number: $e.find('input#ups-account_number').val(),
      user_id: $e.find('input#ups-user_id').val(),
      password: $e.find('input#ups-password').val(),
      name: $e.find('input#company-name').val(),
      email: $e.find('input#company-email').val(),
      phone: $e.find('input#company-phone').val(),
      company: $e.find('input#company-company_name').val(),
      website: $e.find('input#company-company_website').val(),
      title: $e.find('input#company-job_title').val(),
      street1: $e.find('input#address-street1').val(),
      street2: $e.find('input#address-street2').val(),
      city: $e.find('input#address-city').val(),
      state: $e.find('input#address-state').val(),
      postal_code: $e.find('input#address-postal_code').val(),
      country: $e.find('input#address-country').val(),
    }, {
      success() {
        setLocation('/account/carriers');
      },
      error() {
        showError('The data you entered was not accepted by UPS, please ensure all fields are filled out correctly.');
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/views/ups_account_registration_page.js